var t,r;function a(){if(r)return t;r=1;return t=class{constructor(t,r){this.authId=t,this.authToken=r}sign(t){t.parameters["auth-id"]=this.authId,t.parameters["auth-token"]=this.authToken}}}export{a as __require};
